module.exports = __webpack_public_path__ + "img/dynamic-18.76b9318e.png";